export default function runInitialize({ store }) {
  if (store.reloadMinimumData) {
    store.reloadMinimumData();
  }
}
